var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-xl mb-5 pt-3"},[_vm._v("Edit Customer")]),_vm._v(" "),_c('customer-form',{attrs:{"customerToEdit":_vm.customer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }